<template>
    <div class="flex h-screen align-items-center justify-content-center">
        <div style="width: 400px">
            <div class="mb-5 text-center">
                <img
                    src="@/assets/images/Logo_FullColor_DarkMode.svg"
                    alt="Corridor Logo"
                    height="50" />
            </div>
            <slot />
        </div>
    </div>
</template>

<script setup>
// No script logic needed - this is a pure layout component
</script>
